import { baseURL } from "../API/API";

/** Origin of the Laravel app (without /api). */
export function getApiOrigin() {
  try {
    return baseURL.replace(/\/api\/?$/, "");
  } catch {
    return "http://127.0.0.1:8000";
  }
}

export function resolveMediaUrl(path) {
  if (!path || typeof path !== "string") return null;

  const trimmed = path.trim();
  if (!trimmed) return null;

  const origin = getApiOrigin();

  // Case 1: Absolute URL
  if (/^https?:\/\//i.test(trimmed)) {
    if (trimmed.includes("/storage/") || trimmed.includes("/public/storage/")) {
      let pathPart = "";
      try {
        const urlObj = new URL(trimmed);
        pathPart = urlObj.pathname + urlObj.search + urlObj.hash;
      } catch (e) {
        const storageIndex = trimmed.indexOf("/storage/");
        if (storageIndex !== -1) {
          pathPart = trimmed.substring(storageIndex);
        } else {
          const publicStorageIndex = trimmed.indexOf("/public/storage/");
          if (publicStorageIndex !== -1) {
            pathPart = trimmed.substring(publicStorageIndex);
          }
        }
      }

      // Ensure it starts with /public/storage/
      if (pathPart.includes("/public/storage/")) {
        const idx = pathPart.indexOf("/public/storage/");
        pathPart = pathPart.substring(idx);
      } else if (pathPart.includes("/storage/")) {
        const idx = pathPart.indexOf("/storage/");
        pathPart = "/public" + pathPart.substring(idx);
      }

      return `${origin}${pathPart}`;
    }
    return trimmed;
  }

  // Case 2: Relative URL
  let pathPart = trimmed;
  if (pathPart.includes("public/storage/")) {
    const idx = pathPart.indexOf("public/storage/");
    pathPart = "/" + pathPart.substring(idx);
  } else if (pathPart.includes("storage/")) {
    const idx = pathPart.indexOf("storage/");
    pathPart = "/public/" + pathPart.substring(idx);
  } else {
    if (!pathPart.startsWith("/")) {
      pathPart = "/" + pathPart;
    }
  }

  return `${origin}${pathPart}`;
}
